var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { TemplateLibraryDialogService } from './template-library-dialog-service.interface';
let TemplateLibraryCommandContribution = class TemplateLibraryCommandContribution {
    constructor(_templateLibraryDialogService) {
        this._templateLibraryDialogService = _templateLibraryDialogService;
    }
    registerCommands(commandRegistry) {
        commandRegistry.registerCommand({
            id: 'open-template-library',
        }, {
            execute: () => {
                return this._templateLibraryDialogService.open();
            },
        });
        commandRegistry.registerCommand({
            id: 'close-template-library',
        }, {
            execute: () => {
                return this._templateLibraryDialogService.close();
            },
        });
    }
};
TemplateLibraryCommandContribution = __decorate([
    injectable(),
    __param(0, inject(TemplateLibraryDialogService)),
    __metadata("design:paramtypes", [typeof (_a = typeof TemplateLibraryDialogService !== "undefined" && TemplateLibraryDialogService) === "function" ? _a : Object])
], TemplateLibraryCommandContribution);
export { TemplateLibraryCommandContribution };
